<template>
    <div class="space-y-6">
        <div v-if="isLoading" class="flex justify-center items-center">
            <div
                class="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"
            ></div>
        </div>
        <div v-else>
            <SectionCard
                :showFlag="!showPaymentForm"
                title="Quick Pay"
                description="Fill in the details before you pay.  We'll get the rest of your details later"
            >
                <div class="grid grid-cols-2 gap-6 mb-6 pr-16">
                    <div class="col-span-2 md:col-span-1">
                        <TextInput label="Last Name" v-model="last_name" :validation="v$.last_name"></TextInput>
                    </div>
                    <div class="col-span-2 md:col-span-1  md:col-start-1">
                        <TextInput label="Email" v-model="email" :validation="v$.email"></TextInput>
                    </div>

                </div>
                <div class="space-y-3">
                    <BasicVehicleDetails
                        v-for="(vehicle, index) in vehicles"
                        :key="index"
                        v-model="vehicles[index]"
                        :types="prices"
                        :is-last="index == vehicles.length - 1 && index != 0"
                        @remove="vehicles.pop()"
                    ></BasicVehicleDetails>
                </div>
                <button type="button" @click="vehicles.push({})" class="bg-ap-primary text-white px-4 py-2 text-sm rounded-lg mt-4">
                    + Add another vehicle
                </button>

                <template v-slot:footer>
                    <button @click="onSubmit" class="bg-ap-fs-primary rounded-lg px-4 py-2 text-sm text-white">Continue</button>
                </template>
            </SectionCard>

            <SectionCard
                :showFlag="showPaymentForm"
                title="Card Information"
            >
                <template v-slot:header-right>
                    <button class="text-gray-200 border-b border-dashed hover:text-gray-300" @click="showPaymentForm = false">
                        <svg class="w-4 h-4 text-white inline-block mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                        </svg>
                        <span>Edit Details</span>
                    </button>
                </template>

                <StripePaymentForm @price-change="priceChange"></StripePaymentForm>
            </SectionCard>
        </div>

        <AddValetModal v-if="showValetModal" :open="showValetModal" :vehicles="vehicles" @close="showValetModal = false; submitData()"></AddValetModal>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {
    required,
    email,
    minLength,
    helpers,
} from '@vuelidate/validators';
import axios from 'axios';
import SectionCard from './SectionCard.vue';
import StripePaymentForm from './StripePaymentForm.vue';
import BasicVehicleDetails from './BasicVehicleDetails.vue';
import TextInput from '../TextInput.vue';
import AddValetModal from './AddValetModal.vue';
import PromotionInput from './PromotionInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            isLoading: false,
            showPaymentForm: false,
            vehicles: [{}],
            last_name: this.session.last_name,
            email: this.session.email,
            errors: {},
            showValetModal: false,
        };
    },
    validations() {
        return {
            last_name: {
                required: withMessage('Last name is required', required),
            },
            email: {
                required: withMessage('Email is required', required),
                email: withMessage('Email format is invalid', email),
            },
            vehicles: {
                required,
                minLength: minLength(1),
            },
        };
    },
    props: {
        startingPrice: { type: Number, required: false },
        prices: { required: true },
        session: { required: true },
    },
    watch: {
        vehicles: {
            immediate: true,
            deep: true,
            handler(value) {
                this.$emit('vehicleChange', value);
            },
        },
    },
    methods: {
        onSubmit() {
            if (this.vehicles.every((vehicle) => typeof vehicle.valet === 'undefined' || vehicle.valet == null)) {
                this.showValetModal = true;
            } else {
                this.submitData();
            }
        },
        async submitData(e) {
            const result = await this.v$.$validate();

            if (!result) {
                console.log('errors');
                e.preventDefault();
                return false;
            }

            // this.isLoading = true;
            return axios.post('/quick-booking', {
                last_name: this.last_name,
                email: this.email,
                vehicles: this.vehicles,
            }).then(() => {
                this.showPaymentForm = true;
            }).catch((error) => {
                console.log('error', error.response);
                this.errors = error.response.data.errors;
            }).then(() => {
                this.isLoading = false;
            });
        },

        priceChange(prices) {
            this.$emit('priceChange', prices);
        },
    },
    mounted() {
        if (this.session.vehicles != null) {
            this.vehicles = this.session.vehicles;
        }
    },
    components: {
        SectionCard,
        StripePaymentForm,
        BasicVehicleDetails,
        TextInput,
        AddValetModal,
    },
};
</script>
